/** Generated from EFindingBlacklistUpdateType.java. Do not modify this file! */


export type EFindingBlacklistUpdateTypeEntry = 'ADD' | 'REMOVE';

export class EFindingBlacklistUpdateType {
	static readonly ADD = new EFindingBlacklistUpdateType(0, 'ADD');
	static readonly REMOVE = new EFindingBlacklistUpdateType(1, 'REMOVE');
	static readonly values = [
		EFindingBlacklistUpdateType.ADD,
		EFindingBlacklistUpdateType.REMOVE
	];



	private constructor (
		public readonly ordinal: number,
		public readonly name: EFindingBlacklistUpdateTypeEntry,

	){
	}

	toString() {
		return this.name;
	}

	/** Returns the enum value of the provided enum entry. */
	public static valueOf(entry: EFindingBlacklistUpdateTypeEntry): EFindingBlacklistUpdateType;
	/** Returns the enum value of the provided enum entry. Returns undefined if entry was undefined. */
	public static valueOf(entry: EFindingBlacklistUpdateTypeEntry | undefined): EFindingBlacklistUpdateType | undefined;
	public static valueOf(entry: EFindingBlacklistUpdateTypeEntry | undefined): EFindingBlacklistUpdateType | undefined {
		if (entry === undefined) {
			return undefined;
		}
		return EFindingBlacklistUpdateType[entry];
	}
}

